import React from "react";
import Checkout from "../components/checkout/Checkout";

const CheckoutPage = () => {
  return (
    <div>
      <Checkout />
    </div>
  );
};

export default CheckoutPage;
